import { z } from 'zod/v4';
import { DistributionChartPropsBase, DistributionChartSpec } from '@/core';
import { createVisualization } from '../../../plugin-system';
import { BarChartIcon } from '../bar-chart/BarChartIcon';
import { DistributionChartOptionsEditorSettings } from './DistributionChartOptionsEditorSettings';
import { DistributionChartPanel } from './DistributionChartPanel';

const distributionChartSpecSchema = z.object({});

export const DistributionChart = createVisualization(DistributionChartPanel, {
  dashboardConfig: {
    kind: 'DistributionChart',
    mapSpecToProps: (spec: DistributionChartSpec) => {
      const props: DistributionChartPropsBase = { ...spec };
      props.percentileMarkers = spec.percentile_markers;

      return props;
    },
    mapPropsToSpec: (props) => {
      const { percentileMarkers, ...passThrough } = props;
      return {
        ...passThrough,

        percentile_markers: percentileMarkers,
      };
    },
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: DistributionChartOptionsEditorSettings,
      },
    ],
    createInitialOptions: () => ({}),
    enableCompareMode: true,
    schema: distributionChartSpecSchema,
    supportedDataType: 'Distribution',
    icon: BarChartIcon,
  },
});

export type DistributionChartVizProps = React.ComponentProps<typeof DistributionChart.Viz>;
export type DistributionChartVizBaseProps = React.ComponentProps<typeof DistributionChart.VizBase>;
